export default "__VITE_ASSET__BT23ESt7__"